// extracted by mini-css-extract-plugin
module.exports = {"box":"_3RAdAzbBRm2NKgIUIdwmj5","pagination":"_28lwxgSzbljdDwx6KB7DSS","disabled":"_3IMhZkCUdGHLyZhZfoQ5Qi","active":"_273X01ubJH07apCjvqPCSG","more":"_3kzv39JOcXRxsgWObI_D9w"};